import { Tag } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgTag = mkIcon(Tag);
